<template>
  <b-modal
    :hide-footer="true"
    centered
    size="xl"
    :id="visible"
    @hidden="$bvModal.hide(visible)"
  >
    <template #modal-title>
      <strong class="font-size-19">
        Detalhes do Atendimento
      </strong>
    </template>
    <div class="row">
      <div class="col-md-12">
        <print-content>
          <table
            class="table b-table b-table-stacked-xs table-bordered table-sm bg-white mb-0"
          >
            <tbody>
              <tr>
                <td class="pt-2 pb-2">
                  PROTOCOLO: <strong> {{ agendamento?.protocolo }} </strong>
                </td>
                <td class="pt-2 pb-2">
                  ID: <strong> {{ agendamento?.id }} </strong>
                </td>
                <td class="pt-2 pb-2">
                  DATA DA SOLICITAÇÃO: <strong> {{ agendamento?.data_cadastro | formatDate }} </strong>
                </td>
              </tr>
              <tr>
                <td colspan="1">
                  SOLICITANTE: <strong> {{ agendamento?.solicitante }} </strong>
                </td>
                <td colspan="2">
                  TELEFONE: <strong> {{ agendamento?.contato }} </strong>
                </td>
              </tr>
              <tr>
                <td colspan="1">
                  FORMAS DE ACESSO: <strong> {{ agendamento?.forma_acesso?.nome }} </strong>
                </td>
                <td colspan="2">
                  TIPO DE SOLICITAÇÃO: <strong> {{ agendamento?.tipos.map(tipo => tipo?.descricao).join(', ') }} </strong>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  LOCAL ONDE SERÁ REALIZADO O ATENDIMENTO: <strong> {{ agendamento?.local_atendimento?.descricao }} </strong>
                </td>
              </tr>
              <tr>
                <td colspan="1">
                  DATA AGENDADA: <strong> {{ agendamento?.agendamento?.data_agendada }} </strong>
                </td>
                <td colspan="1">
                  HORA: <strong> {{ agendamento?.agendamento?.hora }} </strong>
                </td>
                <td colspan="1">
                  DURAÇÃO: <strong> {{ agendamento?.agendamento?.duracao }} </strong>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  NOME DO(A) TÉCNICO(A): <strong> {{ agendamento?.responsavel_agendamento?.nome }} </strong>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  SERVIÇO SOCIOASSISTENCIAL: <strong> {{ agendamento?.servico }} </strong>
                </td>
              </tr>
              <tr>
                <td colspan="1">
                  RESPONSÁVEL PELO AGENDAMENTO: <strong> {{ agendamento?.tecnico?.nome }} </strong>
                </td>
                <td colspan="2">
                  UNIDADE: <strong> {{ agendamento?.unidade?.nome }} </strong>
                </td>
              </tr>
            </tbody>
          </table>

          <print-footer
            v-if="agendamento?.tecnico?.assinatura"
            :tecnico="agendamento?.tecnico"
            class="mt-0"
            :assinatura="agendamento?.tecnico?.assinatura"
            :wpp="wpp"
            :email="email"
          />

          <form-toggle
              grid="12"
              mt="0"
              v-model="email"
              label="Email"
          />
          <form-toggle
              grid="12"
              mt="0"
              v-model="wpp"
              label="Telefone/WhatsApp"
          />

          <h5 class="mt-4 font-italic">
            Atenção: Na impossibilidade de comparecer no dia e horário agendado, solicitamos comunicar a unidade responsável através do telefone:
            {{ telefone }}, ou ainda pelo e-mail: {{ email }}.
          </h5>

          <h5 class="mt-4 font-italic">
            No dia do atendimento não esqueça de trazer um documento com foto, CPF e um comprovante de residência atualizado, de preferência, a conta de luz.
          </h5>
        </print-content>
      </div>
    </div>
    <section class="row mt-3">
      <div class="col-12 border-top">
        <h4 class="font-weight-bold mt-3 mb-2">
          Contatos da Unidade
        </h4>
      </div>

      <form-input
        grid="6"
        label="E-mail"
        type="email"
        v-model="email"
      />

      <form-input
        label="Telefone"
        grid="6"
        v-mask="'(##) # ####-####'"
        placeholder="(00) 0 0000-0000"
        v-model="telefone"
      />
    </section>
    <section class="d-flex flex-row justify-content-end">
      <b-button
        :title="$t('Imprimir')"
        type="button"
        class="m-0"
        style="padding: 7px 15px"
        v-b-tooltip.hover
        variant="primary"
        @click="print()"
      >
        <i class="fas fa-light fa-print"></i>
      </b-button>
    </section>
  </b-modal>
</template>

<script>
export default {
  name: "AtendimentoImpressaoModal",
  props: [
    "agendamento",
    "visible"
  ],
  data() {
    return {
      email: null,
      telefone: null
    }
  },
  watch: {
    agendamento: {
      handler: function (newVal) {
        this.email = newVal?.unidade?.email;
        this.telefone = newVal?.unidade?.telefone;
      },
      deep: true
    },
  }
}
</script>
